'use strict';

angular.module('domain.agreement', ['ngRoute', 'upResources', 'security.authorization']).config([
	'$stateProvider',
	'$routeGuardProvider',
	'$upModalProvider',
	function ($stateProvider, $routeGuardProvider, $upModalProvider) {
		$stateProvider.state('agreements', {
			url: '/:customerId/agreement/'
		});

		$upModalProvider.modal('editAgreement', {
			templateUrl: require('App/upsales/domain/agreement/views/editAgreement.html?file'),
			controller: 'EditAgreement as EditAgreement',
			style: 'form-wide default',
			hash: true,
			closeOnEscape: false,
			closeOnCurtain: true,
			rememberHeight: true,
			resolve: {
				authUser: function ($routeGuard) {
					return $routeGuard.requireUser();
				},
				meta: function ($modalParams, EditAgreementMeta) {
					return EditAgreementMeta($modalParams);
				}
			}
		});
	}
]);
